import { fetch } from '@/plugin/axios/index.js'
import formAxios from '@/plugin/axios/formAxios.js'


/**
 * 合同添加
 * @param {Object} data 
 */
export function addContract(data) {
  return fetch({
    url: '/financial/contract/maintain/create',
    method: 'POST',
    data
  })
}


/**
 * 合同修改
 * @param {Object} data 
 */
export function updateContract(data) {
  return fetch({
    url: '/financial/contract/maintain/update',
    method: 'POST',
    data
  })
}


/**
 * 合同列表
 * @param {Object} data 
 */
export function getPageList(data) {
  return fetch({
    url: '/financial/contract/maintain/pageList',
    method: 'POST',
    data
  })
}


/**
 * 下载合同导入模板
 * @param {Object} data 
 */
export function exportLiftTemplate() {
  return formAxios({
    url: '/financial/contract/maintain/exportLiftTemplate',
    method: 'POST'
  })
}



/**
 * @param {Object} data
 * 导出
 */
export function exportContract(data) {
  return formAxios({
    url: '/financial/contract/maintain/list/export',
    method: 'POST',
    data
  })
}



/**
 * @param {Object} data
 * 导入
 */
export function importContract(data) {
  return fetch({
    url: '/financial/contract/maintain/importContract',
    method: 'POST',
    data
  })
}


/**
 * @param {Object} data
 * 删除
 */
export function deleteContract(data) {
  return fetch({
    url: '/financial/contract/maintain/delete',
    method: 'POST',
    data
  })
}


/**
 * @param {Object} data
 * 详情
 */
export function getContractDetail(params) {
  return fetch({
    url: '/financial/contract/maintain/detail',
    method: 'GET',
    params
  })
}


/**
 * 下载附件
 * @param {Object} data 
 */
export function downloadAppendFile() {
  return formAxios({
    url: '/financial/contract/maintain/downloadAppendFile',
    method: 'GET'
  })
}


/**
 * @param {Object} data
 * 延期丢失
 */
export function extensionContract(data) {
  return fetch({
    url: '/financial/contract/maintain/extensionContract',
    method: 'POST',
    data
  })
}


/**
 * @param {Object} data
 * 结束
 */
export function finishContract(data) {
  return fetch({
    url: '/financial/contract/maintain/finishContract',
    method: 'POST',
    data
  })
}


/**
 * @param {Object} data
 * 回款列表
 */
export function getCollectionList(data) {
  return fetch({
    url: '/financial/collection/contract/list',
    method: 'POST',
    data
  })
}


/**
 * @param {Object} data
 * 回款添加编辑
 */
export function saveContractCollectionPlan(data) {
  return fetch({
    url: '/financial/collection/contract/collect',
    method: 'POST',
    data
  })
}


/**
 * @param {Object} data
 * 回款删除
 */
export function removeContractCollectionPlan(data) {
  return fetch({
    url: '/financial/collection/employee/remove',
    method: 'POST',
    data
  })
}


/**
 * @param {Object} data
 * 快速生成计划
 */
export function createContractCollectionPlan(data) {
  return fetch({
    url: '/financial/collection/plan/preview',
    method: 'POST',
    data
  })
}






// WEBPACK FOOTER //
// ./src/api/ContractManagement/index.js